import src from "IMAGE";
export default { src, width: 308, height: 311, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
